import axios from "../axios";

//查询用户列表
export const queryUserList = (data) => {
   
    return axios({
        url: "common/query_user_list",
        method: "post",
        data
    })
}

//新增用户
export const addUser = (data) => {
   
    return axios({
        url: "common/add_user",
        method: "post",
        data
    })
}

//修改用户
export const modifyUser = (data) => {
  
    return axios({
        url: "common/modify_user",
        method: "post",
        data
    })
}